import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import img_cross from "@/assets/img/img_cross.png";
import { IGameType, ILanguageType } from "@/types/GlobalTypes";
import nth0WithSup from "@/modules/nth0WithSup";

interface IProps {
	activeGame: IGameType;
	langdata: ILanguageType;

	removeNumberM42: (e: any) => void;
	insertBet: (e: any) => void;
	removeBet: (e: any) => void;

	activateUnsubmittedTicketRow: (e: any) => void;
	addUnsubmittedTicketRow: (e: any) => void;

	mobile: boolean;
}

// COPIED FROM LottoTable
export default class PinballTable extends React.Component<IProps> {
	private addTicketFragment() {
		const { addUnsubmittedTicketRow, activeGame, langdata } = this.props;
		const { pcode } = activeGame;

		return (
			<tr key={"MMG_m26_uT_add"}
				{...{ pcode }}
				onClick={addUnsubmittedTicketRow}

				className="add-ticket">
				<td colSpan={3}>
					{langdata["txt_add_tickets"]}
				</td>
			</tr>
		);
	}

	private unsubmittedTicketRows() {
		const {
			activeGame,
			activateUnsubmittedTicketRow,
			removeNumberM42,
			insertBet,
			removeBet
		} = this.props;

		const {
			activeUnsubmittedTicketRow: activeRow,
			pcode,
			unsubmittedTickets
		} = activeGame;

		return (
			unsubmittedTickets.map((item, ticketindex) => {
				const
					maximumNumberCount = 2,

					numberArray = item.numbers.slice(0, maximumNumberCount),

					numberRowFunction = (num: number, numberindex: number) => {
						const key = "nRF_empty_" + ticketindex + "_" + numberindex;

						if (num === null)
							return <div key={key} className="empty" />;

						return (
							<div key={key}>
								{assetImg(
									"m42",
									num + "",
									`m42_${ticketindex}_${numberindex}`
								)}

								<img className="delete"
									src={img_cross}

									{...{
										pcode,
										ticketindex,
										numberindex
									}}

									onClick={removeNumberM42}
									alt={"ball " + num}
								/>
							</div>
						);
					},

					// Empty number check
					hasEmptyNumberArray = activeRow === ticketindex &&
						numberArray.filter(num => num !== null).length === 0,

					// Empty bet check
					hasEmptyBet = activeRow === ticketindex &&
						unsubmittedTickets[activeRow].bet === 0;

				// Set first row
				return (
					<tr key={"MMG_m42_uT_" + ticketindex}
						className={activeRow === ticketindex ? "active" : ""}
						{...{
							pcode,
							rowidx: ticketindex
						}}
						onClick={activateUnsubmittedTicketRow}>

						<td>
							<div className="ticket-index">
								{ticketindex + 1}
							</div>
						</td>

						{/* Guess column */}
						<td className={hasEmptyNumberArray ? "empty-guess" : ""}>
							{numberArray.map(numberRowFunction)}
						</td>

						{/* Bet column */}
						<td className={"sl-bet" +
							(hasEmptyBet ? " blink" : "")}

							{...{
								index: ticketindex,
								pcode
							}}

							onClick={insertBet}
						>
							<div className="bet-label">
								{item.bet}
							</div>

							<img className="delete"
								src={img_cross}

								{...{
									pcode,
									ticketindex
								}}

								onClick={removeBet}
								alt={"bet " + ticketindex}
							/>
						</td>
					</tr>
				);
			})
		);
	}

	render() {
		const { activeGame, langdata } = this.props;

		const { pcode } = activeGame;

		return (
			<div className="table-unsubmitted-tickets"
				{...{ pcode }}>

				<div className="scrollable-area">
					<table>
						<thead>
							<tr>
								<td />
								<td>
									{nth0WithSup(0)}
									{nth0WithSup(1)}
								</td>
								<td>{langdata["txt_bet"]}</td>
							</tr>
						</thead>

						<tbody>
							{this.unsubmittedTicketRows()}
							{this.addTicketFragment()}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}
